<template>
  <div>
    <Mypostheader />
    <div class="cards-section">
      <div class="cards-collection">
        <div
          v-for="(service, index) in services"
          :key="index"
          @click="navigateToUser(service.servicesID, service.userID)"
          class="cards"
        >
          <div class="card-img">
            <!-- <img src="../icons/cardFrame.png" alt="room images" /> -->
            <img
              :src="service.imageUrl || '../icons/cardFrame.png'"
              alt="room images"
            />

            <div class="overlay-content">
              <div class="overlay-header">
                <div class="profile-img">
                  <img src="../icons/userIcon.svg" alt="profileImg" />
                </div>
                <div class="user-info">
                  <div class="user-name">
                    <p>{{ service.userDetails?.userName || "Unknown user" }}</p>
                    <img
                      class="badge"
                      src="../icons/Verified.svg"
                      alt="badge"
                    />
                    <span class="time">· 8h</span>
                  </div>
                </div>
              </div>

              <div class="overlay-bottom">
                <div class="overlay-text">
                  <p class="card-heading">
                    {{ truncate(service.servicesName, 25) }}
                  </p>
                  <p class="card-desc">
                    {{ truncate(service.Description, 40) }}
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div class="card-details">
            <div class="info-row">
              <div class="info-item">
                <img src="../icons/locIcon.svg" alt="location" />
                <p>{{ service.location || "New Jersey" }}</p>
              </div>
              <div class="card-servicetype small">
                <p>{{ service.serviceType1 || "Rental" }}</p>
              </div>
            </div>

            <div class="info-row">
              <div class="info-item">
                <img src="../icons/callIcon.svg" alt="phone" />
                <p>{{ service.contact || "+1 989 789 5678" }}</p>
              </div>
            </div>
          </div>

          <div class="card-btn">
            <!-- <button class="outline" @click="editpost()">Edit Post</button> -->
            <button class="outline" @click.stop="editpost(service.servicesID)">Edit Post</button>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "../../../public/css/main.css";
import Mypostheader from "./Mypostheader.vue";

export default {
  components: {
    Mypostheader,
  },
  props: {
    services: {
      type: Array,
      required: true,
    },
  },
  mounted() {
    if (import.meta.env.DEV) {
      console.log("📦 Received services in myposts:", this.services);
    }
  },
  methods: {
    truncate(text, length) {
      if (!text) return "";
      return text.length > length ? text.substring(0, length) + "..." : text;
    },
    navigateToUser(servicesID, userID) {
      this.$router.push({
        name: "ViewAds",
        query: {
          servicesID: servicesID,
          userID: userID,
        },
      });
    },
    // editpost(servicesID) {
    //   this.$router.push({
    //     name: "EditAdPage",
    //     query: {
    //       servicesID: servicesID,
          
    //     },
    //   });
    // },
      editpost(servicesID) {
      this.$router.push({
        name: "EditAdPage",
        query: {
          servicesID: servicesID,
          from: "mypostadd" 
        },
      });
    },
  },
};
</script>

<style scoped>
.cards-section {
  width: 100%;
  max-width: 1280px;
  margin: 24px auto;
  box-sizing: border-box;
}

.cards-collection {
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
  padding: 0 40px;
  justify-content: flex-start;
}

.cards {
  flex: 1 1 calc(33.333% - 24px);
  max-width: 390px;
  border: 1px solid #e9eaeb;
  border-radius: 16px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  background: #fff;
  overflow: hidden;
  cursor: pointer;
}

/* ====================== */
/* IMAGE + OVERLAY        */
/* ====================== */

.card-img {
  position: relative;
  width: 100%;
  height: 260px;
  border-radius: 16px;
  overflow: hidden;
}

.card-img img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 16px;
}

.overlay-content {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 16px;
  color: #fff;
  transition: background 0.3s ease;
}

.overlay-header {
  display: flex;
  align-items: center;
  gap: 10px;
}

.overlay-header .profile-img {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  overflow: hidden;
  border: 2px solid white;
}

.overlay-header img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.overlay-header .user-name {
  display: flex;
  align-items: center;
  gap: 5px;
}

.overlay-header .user-name p {
  font-size: 14px;
  font-weight: 600;
  margin: 0;
  color: #000000;
  font-family: var(--font-primary);
}

.overlay-header .badge {
  width: 14px;
  height: 14px;
}

.overlay-header .time {
  font-size: 14px;
  font-weight: 400;
  color: #000000;
  font-family: var(--font-primary);
}

.overlay-bottom {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.overlay-text .card-heading {
  font-size: 20px;
  font-weight: 600;
  margin: 0;
  line-height: 30px;
  color: #181d27;
  font-family: var(--font-primary);
}

.overlay-text .card-desc {
  font-size: 16px;
  font-weight: 400;
  color: #535862;
  margin: 0;
  line-height: 24px;
}

.card-servicetype {
  align-self: flex-start;
  border-radius: 6px;
  border: 1px solid transparent;
  background: linear-gradient(white, white) padding-box,
    linear-gradient(90deg, #e33629, #017dca) border-box;
}

.card-servicetype p {
  background-image: linear-gradient(90deg, #e33629, #017dca);
  -webkit-background-clip: text;
  color: transparent;
  font-weight: 500;
  font-size: 12px;
  margin: 0;
  font-family: var(--font-primary);
  line-height: 15px;
}

.card-details {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 16px;
  box-sizing: border-box;
}

.info-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.info-item {
  display: flex;
  align-items: center;
  gap: 8px;
}

.info-item img {
  width: 18px;
  height: 18px;
}

.info-item p {
  margin: 0;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  color: #181d27;
  font-weight: 500;
   max-width: 160px;         /* 👈 set width */
  white-space: nowrap;      /* 👈 no wrap */
  overflow: hidden;         /* 👈 hide overflow */
  text-overflow: ellipsis;
}

/* SMALL BADGE STYLE */
.card-servicetype.small {
  height: 28px;
  flex-shrink: 0;
}

.card-servicetype.small p {
  font-size: 12px;
  padding: 6px 10px;
  border-radius: 4px;
}

@media (max-width: 1280px) {
  .cards {
    flex: 1 1 calc(45% - 24px);
    max-width: 340px;
  }
}

@media (max-width: 768px) {
  .cards {
    flex: 1 1 100%;
    max-width: 100%;
  }

  .card-btn .outline {
    font-size: 13px;
    padding: 8px 12px;
  }
}
@media (max-width: 480px) {
  .cards-collection {
    padding: 0px !important;
  }
}
</style>
